import Echo from "laravel-echo";
import Pusher from "pusher-js";
import api from "./axiosConfig";

window.Pusher = Pusher;

const getEchoConfig = () => {
  const key = process.env.REACT_APP_PUSHER_APP_KEY;
  const cluster = process.env.REACT_APP_PUSHER_APP_CLUSTER;

  if (!key || !cluster) {
    return null;
  }

  return { key, cluster };
};

export const initializeEcho = () => {
  const config = getEchoConfig();
  if (!config) {
    return null;
  }

  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
  const authEndpoint = `${apiUrl}/broadcasting/auth`;

  const echo = new Echo({
    broadcaster: "pusher",
    key: config.key,
    cluster: config.cluster,
    forceTLS: false,
    enabledTransports: ["ws", "wss"],
    authorizer: (channel) => ({
      authorize: (socketId, callback) => {
        api
          .post(authEndpoint, {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((res) => callback(null, res.data))
          .catch((err) => {
            callback(err);
          });
      },
    }),
  });

  if (process.env.NODE_ENV === "development") {
    echo.connector.pusher.connection.bind("state_change", (state) => {
      console.debug("Pusher state:", state.previous, "->", state.current);
    });
    echo.connector.pusher.connection.bind("error", (error) => {
      console.error("Pusher connection error:", error);
    });
  }

  return echo;
};
